const COLOR_PALETTE = ["#10b981", "#3b82f6", "#8b5cf6", "#f59e0b", "#ef4444"];

export default COLOR_PALETTE;